// This file enables: import 'probe.gl/bench'.
// Note: Must be published using package.json "files" field
module.exports = require('@probe.gl/env');
